import type { FaireProductEntity } from "../../entity_types/product";

export const p_hxer2rczw3: FaireProductEntity = {
  token: "p_hxer2rczw3",
  type: "product",
  name: "Solid Color Thin 7/10 Sleeve Short Blazer Coat",
  brandToken: "b_3n88yzphkb",
  brandName: "UZ Wholesale Store",
  imageUrl:
    "https://cdn.faire.com/fastly/0d01ae72852754197cd23a734c5bdaf9660e1535f8578d4f612c910e58276d37.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a36d5f40b5f74d821542ac8dc891f76e5b5e461a7d630801f71a642cb0998ad4.jpeg",
    "https://cdn.faire.com/fastly/0caf3aa3e5fed858a655d2507833fc2ad206cf0d8e3069a72206fce8eac12556.jpeg",
    "https://cdn.faire.com/fastly/019abaf8cc3f79a12e7ff2303954c211e14d0b59cc4e25ca580d6fc0a31a25a8.jpeg",
  ],
  priceDollars: 18.49,
  description:
    "\nMaterial: Polyester 100%\n\nStyle:Loose,Intellectual,All-match,Look-younger\n\nFeature:Thin,Plain\n\nNeckline:Tailored\n\nOccasion:Going out,Casual,Office,Workwear Suits,Urban,Simple,Artistic Retro,Girlish Sweetness,Light Maturity,Stylish Selection,Leisure Fashion\n\nSeasons:Spring,Summer,Autumn\n\nType:Suit Jacket\n\nSleeve Length:Seven-Quarter Sleeves\n\nSleeve Style:Raglan Sleeve\n\nSize M (inch) : Bust= 35.10 ; Waist= 31.20 ; Shoulder= 14.63 ; Length= 25.74 ; \n\nSize L (inch) : Bust= 36.66 ; Waist= 32.76 ; Shoulder= 15.02 ; Length= 26.13 ; \n\nSize XL (inch) : Bust= 38.22 ; Waist= 34.32 ; Shoulder= 15.48 ; Length= 26.13 ; \n\nSize 2XL (inch) : Bust= 39.78 ; Waist= 35.88 ; Shoulder= 15.99 ; Length= 26.52 ; \n\nSize 3XL (inch) : Bust= 41.34 ; Waist= 37.44 ; Shoulder= 16.58 ; Length= 26.52 ; \n\nSize 4XL (inch) : Bust= 42.90 ; Waist= 39.00 ; Shoulder= 17.16 ; Length= 26.91 ; \n",
  tags: [],
  msrpDollars: 36.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:52.693Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
